class quiz {
  constructor() {
    // this.pageVal=1;
    // this.progressButton();
    this.navLink();
    //this.addPlaceholder();
    // this.asnwerClick();
  }
  addPlaceholder() {
    const inputField = document.querySelector('#tfa_1');
    // console.log("kdjsldfjsf"+inputField);
    if (inputField != null) inputField.placeholder = 'Your email address';
  }

  navLink() {
    const lnk = document.querySelectorAll('.nav-lnk');
    const frmquiz = document.querySelector('#frmquiz');
    const firstEndpoint = frmquiz.getAttribute('data-endpoint-first');
    const secondEndpoint = frmquiz.getAttribute('data-endpoint-second');
    const quizType = frmquiz.getAttribute('data-type');
    var isEligible = [];
    const total_steps = document.querySelector('#totalQuiz');
    lnk.forEach((nav, index) => {
      // console.log(nav);
      nav.addEventListener('click', (e) => {
        e.preventDefault();
        const step_target = e.target.dataset.step;
        const ansField = e.target.dataset.field;
        const conditionStr = e.target.dataset.condition;

        var condArr = '';
        var condition = '';
        var conAns = '';
        if (conditionStr != undefined && conditionStr != '') {
          condArr = conditionStr.split(/\s+/);
          condition = condArr[0];
          conAns = conditionStr.slice(condition.length + 1);
        }

        if (ansField != null) {
          const radioButtons = document.getElementsByName(ansField);

          let selectedValue;
          for (const radioButton of radioButtons) {
            if (radioButton.checked) {
              selectedValue = radioButton.value;
              break;
            }
          }
          const ansError = document.querySelector(
            '#answerError-' + (step_target - 1)
          );
          if (selectedValue == null && selectedValue == undefined) {
            // console.log("here we are: "+ "#answerError-"+(step_target-1));
            document
              .querySelector('#errorMsg-' + (step_target - 1))
              .classList.remove('d-none');
            ansError.textContent = 'Please select an option';
            ansError.classList.add('eyebrow-2', 'text-yellow');
            return false;
          } else {
            document
              .querySelector('#errorMsg-' + (step_target - 1))
              .classList.add('d-none');
            ansError.textContent = '';
            ansError.classList.remove('eyebrow-2', 'text-yellow');
          }
          if (condition == '!=') {
            if (selectedValue != conAns) isEligible[step_target - 2] = true;
            else isEligible[step_target - 2] = false;
          }
          if (condition == '==') {
            if (selectedValue == conAns) isEligible[step_target - 2] = true;
            else isEligible[step_target - 2] = false;
          }
        }
        if (quizType == 'all-true') {
          if (step_target == parseInt(total_steps.value) + 1) {
            if (isEligible.indexOf(false) !== -1)
              frmquiz.action = secondEndpoint;
            else frmquiz.action = firstEndpoint;
            frmquiz.submit();
            return false;
          }
        } else {
          if (step_target == parseInt(total_steps.value) + 1) {
            if (
              isEligible.filter((x) => x == false).length >=
              Math.ceil(total_steps.value / 2)
            )
              frmquiz.action = secondEndpoint;
            else frmquiz.action = firstEndpoint;
            frmquiz.submit();
            return false;
          }
        }

        const qt = document.querySelector('#question-' + step_target);
        if (qt != null) qt.classList.add('js-quiz-done');
        const question = document.querySelectorAll('.question');
        question.forEach((element) => {
          if (!element.classList.contains('d-none'))
            element.classList.add('d-none');
          if (element.classList.contains('quest-' + step_target))
            element.classList.remove('d-none');
        });
      });
    });
  }

  progressButton() {
    // const field = document.querySelector('[name="tfa_4"]');
    // const goto = document.querySelectorAll('.goto-quiz');
    // for (const question of goto) {
    //     question.addEventListener('click', (e) => {
    //         const radioButtons = document.getElementsByName('tfa_4');
    //         let selectedValue;
    //         for (const radioButton of radioButtons) {
    //             if (radioButton.checked) {
    //                 selectedValue = radioButton.value;
    //                 break;
    //             }
    //         }
    //         if (selectedValue) {
    //             console.log("Selected Value: " + selectedValue);
    //         } else {
    //             console.log("No radio button selected");
    //         }
    //     });
    // }
    // const goto = document.querySelectorAll('.goto-quiz');
    // for (const question of goto) {
    //     question.addEventListener('click', (e) => {
    //         var step = e.target.getAttribute('stepcount');
    //         const question = document.querySelectorAll(".question");
    //         const items = document.querySelectorAll('.pro-quiz');
    //         console.log(this.pageVal + '---' + step);
    //         items.forEach(q => {
    //             if(q.classList.contains('js-quiz-done'))
    //                 q.classList.remove('js-quiz-done');
    //         });
    //         document.querySelector("#question-"+step).classList.add('js-quiz-done');
    //         question.forEach(element => {
    //             if(!element.classList.contains('d-none'))
    //                 element.classList.add('d-none');
    //             if(element.classList.contains('quest-'+step))
    //                 element.classList.remove('d-none');
    //         });
    //     })
    // }
  }
}
export default quiz;
new quiz();
